<div class="bg-theme-blue rounded-xl w-full h-full">
  <div class="content absolute left-0 top-0 w-[100%] hidden p-5">
    <div class="absolute left-0 sm-home:left-65 top-0 w-38 2xs:w-64 md:left-84 lg:left-132 2xl:left-185
      h-29 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-blue/home-why-yellow-cloud.svg)] bg-right-top bg-contain bg-no-repeat">
    </div>
    <div class="absolute left-0 w-[600px] lg:w-[824px] top-70 sm-home:top-75 h-30
    bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-blue/home-why-pink-line-2.svg)] bg-right-bottom bg-contain bg-no-repeat">
    </div>
    <div class="absolute sm-home:ml-[24px] left-4 sm-home:left-85 md:left-102 lg:left-152 2xl:left-170
          top-78 sm-home:top-58 2xl:top-58
          w-48 sm-home:w-35 2xl:w-70
          h-32 sm-home:h-52 bg-center sm-home:bg-center 2xl:bg-center rounded-xl  bg-cover bg-no-repeat
          bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/subscription/event-18.webp)]">
    </div>
    <div class="absolute left-4 sm-home:left-10 top-7 2xs:top-12 w-55 xs-home:w-[290px]  2xs:w-96 lg:w-110 2xl:w-140 h-25">
      <h3 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold">Nos valeurs : plaisir et partage, bienveillance et parité.</h3>
      <p class="font-theme-source text-sm xs-home:text-base lg:text-base text-theme-black mt-3 sm-home:mt-5 lg:mt-3 mr-7 xs:mr-2 2xs:mr-2 sm-home:mr-32 lg:mr-12">
        Parce qu’aimer c’est oser, on met tout en oeuvre pour te permettre de sauter le pas ! Hâte-toi à la découverte en toute confiance, nous veillons
        à ce que le respect, l’éthique et le plaisir partagé soient tes guides tout au long de ton expérience.
      </p>
    </div>
  </div>
</div>

